import {
  getBlockQuery,
  useSanityQuery,
  getFileQuery
} from '../core/useSanityQuery';
import { TermsOfPurchasePageQuery } from '../../types/sanity-types';

export const SANITY_TERMS_OF_PURCHASE_QUERY = `
    *[_id == "global-termsOfPurchasePage"][0] {
    ...,
    ${getBlockQuery('intro')},
    ${getBlockQuery('content')},
    ${getFileQuery('file')}
    }
`;

export function useSanityTermsOfPurchase() {
  const termsOfPurchasePageQueryResult = useSanityQuery<
    TermsOfPurchasePageQuery
  >({
    variables: { query: SANITY_TERMS_OF_PURCHASE_QUERY }
  });
  return termsOfPurchasePageQueryResult;
}
